import { mapValues } from 'lodash';
import keyBy from 'lodash/keyBy';
import uniqueId from 'lodash/uniqueId';
import { createSelector } from 'reselect';

import { IServices } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import headerDefaultLinks from '~/src/features/_layout/Header/links.json';
import { TState } from '~/src/store';

export const selectClientProducts = (state: TState) => {
    return state.auth.clientProducts;
};

export const getProductPredicate = (productCheck: EProductsId) =>
    (clientInfo: IServices) => clientInfo.productId === productCheck;

const productInfoPredicates: Record<string, (clientInfo: IServices) => boolean> = {
    '/lk/settings': getProductPredicate(EProductsId.internet),
    '/lk/settings/phone': getProductPredicate(EProductsId.telephony),
};

const shouldBeDisplayed = (clientProductsServices: IServices[]) => (link?: string) => {
    return link && productInfoPredicates[link]
        ? clientProductsServices.some(productInfoPredicates[link])
        : true;
};

export interface ILinksData {
    id: string,
    text: string,
    link?: string,
    action?: string,
    dataTest?: string,
    isLogout?: string,
}

interface IClientPersonalLinksForHeader {
    links: ILinksData[],
    linksForActionSearch: Record<string, { isLogout?: string, action?: string}>,
    isNeedToRequest: boolean,
}

export const selectClientPersonalLinksForHeader = createSelector(
    selectClientProducts,
    (products): IClientPersonalLinksForHeader => {
        const clientProductsServices = products?.services ?? [];
        const shouldBeDisplayedFilter = shouldBeDisplayed(clientProductsServices);

        const links: ILinksData[] = headerDefaultLinks
            .filter(({ link }) => shouldBeDisplayedFilter(link))
            .map((item) => ({
                ...item,
                id: uniqueId('auth-link_'),
            }));


        const linksForActionSearch = mapValues(
            keyBy(links, 'id'),
            ({ isLogout, action }) => ({ isLogout, action }),
        );

        return {
            links,
            linksForActionSearch,
            isNeedToRequest: !products,
        };
    },
);

export const selectProductIds = createSelector(
    selectClientProducts,
    (products) => {
        if (!products) {
            return [EProductsId.internet]; // default
        }
        return products.services.map(product => product.productId);
    },
);
